import mitt, { Emitter} from './src/emitter'
export const emitter: Emitter = mitt()
export default emitter
